import { useGet } from "../../components/Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import Ressource from "../../../app/components/Ressource/Ressource.tsx";
import TYPE_RESSOURCE from "../../../app/enum/TypeRessource.tsx";
import CodeLivretAccueil from "../../../commun/GlobalConstants.tsx";
const LivretAccueilRessource = () => {
  const ressourcePDF = useGet(
    url`/api/public/ressource/get-ressource/` + CodeLivretAccueil,
    {},
  );
  return (
    <Ressource
      ressource={{
        url: ressourcePDF.data?.url,
        telechargeable: ressourcePDF.data?.telechargeable,
      }}
      type={TYPE_RESSOURCE.PDF}
    />
  );
};
export default LivretAccueilRessource;
